
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * SocialTradingOrderType enum
 */
class SocialTradingOrderType {
  /**
   * Initialize enum with a given value
   * @param {SocialTradingOrderType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof SocialTradingOrderType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!SocialTradingOrderType}
   * @param {!SocialTradingOrderType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SocialTradingOrderType)) {
      throw new TypeError('Instance of SocialTradingOrderType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!SocialTradingOrderType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!SocialTradingOrderType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === SocialTradingOrderType.REGULAR.value) {
      return 'REGULAR'
    }
    if (this.value === SocialTradingOrderType.MASTER_ORDER.value) {
      return 'MASTER_ORDER'
    }
    if (this.value === SocialTradingOrderType.INVESTOR_ORDER.value) {
      return 'INVESTOR_ORDER'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!SocialTradingOrderType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!SocialTradingOrderType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!SocialTradingOrderType} Created enum
   */
  static fromObject (other) {
    return new SocialTradingOrderType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
SocialTradingOrderType.REGULAR = new SocialTradingOrderType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
SocialTradingOrderType.MASTER_ORDER = new SocialTradingOrderType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
SocialTradingOrderType.INVESTOR_ORDER = new SocialTradingOrderType(0 + 2)

export { SocialTradingOrderType };

/**
 * Fast Binary Encoding SocialTradingOrderType field model
 */
class FieldModelSocialTradingOrderType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelSocialTradingOrderType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelSocialTradingOrderType}
   * @param {SocialTradingOrderType=} defaults Default value, defaults is new SocialTradingOrderType()
   * @returns {!SocialTradingOrderType} Result value
   */
  get (defaults = new SocialTradingOrderType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new SocialTradingOrderType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelSocialTradingOrderType}
   * @param {!SocialTradingOrderType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelSocialTradingOrderType };
